import React from "react";
import PortfolioAbout from "../container/portfolioAbout/PortfolioAbout";
import PortfolioStory from "../container/portfolioStory/PortfolioStory";
import PortfolioDesign from "../container/portfolioDesign/PortfolioDesign";
import PortfolioStudy from "../container/portfolioStudy/PortfolioStudy";
import PortfolioRelated from "../container/portfolioRelated/PortfolioRelated";

const DrapMe = () => {
  return (
    <div>
      <PortfolioAbout />
      <PortfolioStory />
      <PortfolioDesign />
      <PortfolioStudy />
      <PortfolioRelated />
    </div>
  );
};

export default DrapMe;
